export default "__VITE_ASSET__MJu4p_jy__"